var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center","align":"center","dense":""}},[_c('v-col',{staticClass:"shrink"},[_vm._t("default")],2),_c('v-col',{staticClass:"shrink"},[_c('vs-button',{attrs:{"label":"Reset filters","type":"secondary","small":""},on:{"click":_vm.resetFilters}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }